import React, { useState } from 'react';
import GroupEditor from "../GroupEditor";
import useLocalStorage from "../../hooks/useLocalStorage";

function PowerOfTwo() {
    const [script, setScript] = useLocalStorage('powerOfTwoScript', `function isPowerOfTwo(n) {
    
}
    `);
    const [resultText, setResultText] = useState('');
    const [syntaxError, setSyntaxError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [resultTextCss, setResultTextCss] = useState('');
    const [srcDoc, setSrcDoc] = useState('');

    const testCases = [
        { input: 1, expected: true },
        { input: 16, expected: true },
        { input: 3, expected: false },
        { input: 1024, expected: true },
        { input: 0, expected: false },
        { input: -8, expected: false }
    ];

    function executeScript() {
        setSyntaxError(false);
        setErrorMessage('');
        setResultText('');

        try {
            const results = testCases.map(({ input }) => {
                const scriptFunction = new Function(`
                    ${script}
                    return isPowerOfTwo(${JSON.stringify(input)});
                `);
                return { input, result: scriptFunction() };
            });

            const formattedOutput = results.map(({ input, result }) =>
                `<div><strong>Input:</strong> ${input} | <strong>Output:</strong> ${result}</div>`
            ).join('');
            setSrcDoc(`<!DOCTYPE html><html><body>${formattedOutput}</body></html>`);

            checkPassed(results.map(r => r.result));
        } catch (e) {
            setSyntaxError(true);
            setResultTextCss('');
            setResultText('Ergebnis kann nicht ausgewertet werden, da dein Code noch einen oder mehrere Syntaxfehler hat:');
            setErrorMessage(e.message);
            setSrcDoc(`<!DOCTYPE html>
                <html>
                <head><style>body { font-family: Arial, sans-serif; color: red; }</style></head>
                <body><div>Fehler: ${e.message}</div></body>
                </html>`);
        }
    }

    function checkPassed(results) {
        const isCorrect = results.every((result, index) => result === testCases[index].expected);

        if (isCorrect) {
            setResultTextCss('success-result');
            setResultText("Deine Lösung ist korrekt!");
        } else {
            setResultTextCss('error-message');
            setResultText("Deine Lösung ist leider falsch. Bitte überprüfe deinen Code und versuche es erneut.");
        }
    }

    return (
        <>
            <div className="aufgaben-container">
                <h2>Kaputte Potenz-von-Zwei Überprüfung</h2>
                Deine Aufgabe ist es, eine Funktion zu erstellen, die überprüft, ob eine gegebene Zahl eine Potenz von zwei ist.
                <br/><br/>
                Anforderungen:<br/>
                1) Die Funktion soll überprüfen, ob eine Zahl eine Potenz von zwei ist.<br/>
                2) Sie soll negative Zahlen und 0 korrekt behandeln.<br/>
                3) Zusätzliche Herausforderung: Kannst du es ohne Schleifen oder Rekursion lösen?
                <br/><br/>
                Sobald du deinen Code implementiert hast, kannst du ihn ausführen, um zu sehen, ob die Überprüfung korrekt ist.
            </div>


            <div className="aufgaben-container">
                <GroupEditor
                    language="javascript"
                    value={script}
                    onChange={setScript}
                    editorKey="powerOfTwoScript"
                />
            </div>

            <button className="submit-code-button" onClick={executeScript}>▶ Code ausführen</button>

            <div className="ergebnis-text">
                Ergebnis: <br/>
                <div className={resultTextCss}>{resultText}</div>
                {syntaxError && <div className="error-message">{errorMessage}</div>}
            </div>

            <div className="result-frame">
                <iframe
                    title="console-output"
                    srcDoc={srcDoc}
                    sandbox="allow-scripts"
                    width="100%"
                    height="40%"
                />
            </div>
        </>
    );
}

export default PowerOfTwo;